import React from 'react';

function KeySkillsSection() {
  const skills = [
    {
      title: "Backend Development",
      description: "Building robust and scalable server-side applications",
    },
    {
      title: "System Design",
      description: "Designing and implementing distributed architectures and complex systems",
    },
    {
      title: "Cloud & Infrastructure",
      description: "Working with cloud platforms and automating deployment pipelines",
    },
    {
      title: "Data Management",
      description: "Managing and optimizing data storage and retrieval solutions",
    },
  ];

  return (
    <section className="bg-bg-dark text-text-gray py-24 border-y border-border-subtle">
      <div className="max-w-6xl mx-auto px-5">
        <h2 className="text-4xl text-text-white font-bold relative after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:bg-accent-red after:rounded-sm after:bottom-[-15px] text-center mb-8">
          My Expertise
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-10">
          {skills.map((skill, index) => (
            <div
              key={index}
              className="relative bg-white/5 p-8 rounded-lg text-center shadow-lg transition-all duration-300 hover:-translate-y-2 hover:shadow-xl border border-border-subtle overflow-hidden"
            >
              <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center pointer-events-none">
                <span className="absolute top-4 left-4 text-7xl font-extrabold text-white opacity-5">
                  {index + 1}
                </span>
              </div>
              <h3 className="text-xl text-text-white mb-4 font-semibold relative z-10">{skill.title}</h3>
              <p className="text-base text-text-gray relative z-10">{skill.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default KeySkillsSection;